<shared-ceops></shared-ceops>
<common-nike-connect-overlay></common-nike-connect-overlay>
<my-account-components-simple-login-header *ngIf="isPageWithSimpleHeader"></my-account-components-simple-login-header>

<div id="app-container" class="app-container hmf-mx-auto" role="main">
	<router-outlet></router-outlet>
</div>

<my-account-components-simple-login-footer *ngIf="isPageWithSimpleHeader"></my-account-components-simple-login-footer>
